module.exports = __webpack_public_path__ + "img/visa.aec316b7.svg";